import React, { PropTypes } from 'react';
import { IconButton } from 'material-ui';
import {
  getStatusColor,
  getStatusIcon,
} from '../../contractingUtils';
import ContractorMenu from './change-status-menu-Contractor.jsx';
import { getShownState } from '../../contractingUtils';
import { toLaxTitleCase } from 'titlecase';

const LeftNavStatuses = ({
  contractState,
  changeContractStateTo,
  contractId,
  files,
  companyType,
  locationId,
  originFrom,
  buyerChecked,
  buyerDownloaded,
}) => {
  if (contractState === 'draft' || contractState === 'template' || !contractState) return <span/>;
  const shownStatus = getShownState({
    companyType,
    locationId,
    state: contractState,
    hasSeenResponseWizard: 'na',
    originFrom,
    buyerChecked,
    buyerDownloaded,
    files,
  });
  const capitalizedStatus = toLaxTitleCase(shownStatus);
  const propsForMenu = {
    state: contractState,
    shownStatus,
    changeContractStateTo: changeToState => changeContractStateTo(changeToState, { [contractId]: contractId }),
    locationId,
    files,
  };
  return (
    <div className="flex-tc-sb" style={{ borderBottom: '1px solid #d9d9d9' }}>
      <div>
        <IconButton
          iconClassName={getStatusIcon(shownStatus)}
          iconStyle={{ color: getStatusColor(shownStatus) }}
        />
        <span style={{ color: getStatusColor(shownStatus), position: 'relative', top: '-4px' }}>{capitalizedStatus}</span>
      </div>
      {
        companyType === 'Supplier' ? <span/> : <ContractorMenu {...propsForMenu} />
      }
    </div>
  );
};

LeftNavStatuses.propTypes = {
  contractState: PropTypes.string,
  changeContractStateTo: PropTypes.func,
};

export default LeftNavStatuses;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/left-nav/left-nav-status.jsx